import styled from 'styled-components';
import { ServicesCardsContainer } from './ServicesCardsContainer';

export const ProjectsCardsContainer = styled(ServicesCardsContainer)`
  @media (min-width: 1200px) {
    width: 100%;
  }
`;
